import { render, staticRenderFns } from "./AppointmentTracking.vue?vue&type=template&id=af43fa66&"
import script from "./AppointmentTracking.vue?vue&type=script&lang=js&"
export * from "./AppointmentTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports